export default "__VITE_ASSET__BT30jEwh__"